import PropTypes from 'prop-types';
//import { Link } from 'react-router-dom';

// material-ui
//import { ButtonBase } from '@mui/material';

// project import
import LogoMain from 'components/logo-main';
////import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
//import { APP_DEFAULT_PATH } from 'config';
//import useAuth from 'hooks/useAuth';
import { Box } from '@mui/system';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ reverse, isIcon, sx, to }) => {
  //const { isLoggedIn } = useAuth();

  /*return (
    <ButtonBase disableRipple {...(isLoggedIn && { component: Link, to: !to ? APP_DEFAULT_PATH : to, sx })}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );*/

  return (
    <Box sx={sx} mb={0} >
      {isIcon ? <LogoIcon /> : <LogoMain />}
    </Box>
  )
};

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
